var _path, _rect, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: "7.23mm",
    height: "7.23mm",
    viewBox: "0 0 20.5 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25,20.5C4.6,20.5,0,15.9,0,10.25S4.6,0,10.25,0s10.25,4.6,10.25,10.25-4.6,10.25-10.25,10.25ZM10.25,1.5C5.43,1.5,1.5,5.43,1.5,10.25s3.93,8.75,8.75,8.75,8.75-3.93,8.75-8.75S15.07,1.5,10.25,1.5Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.51,
    y: 4.9,
    width: 1.5,
    height: 8.54,
    transform: "translate(-4.06 8.53) rotate(-45)",
    fill: "currentColor"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "14.25 15.1 9.19 15.1 9.19 13.6 12.75 13.6 12.75 10.14 14.25 10.14 14.25 15.1",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterIco);
export default __webpack_public_path__ + "static/media/register-ico.b3bcabaa777c72072086e47fd855ca78.svg";
export { ForwardRef as ReactComponent };